import { generateUtilityClasses } from '@mui/material';

export const sectionMessageClasses = generateUtilityClasses('SectionMessage', [
  'root',
  'icon',
  'textsContainer',
  'title',
  'body',
  'closeButton',
]);

export const sectionMessageLinkClasses = generateUtilityClasses('SectionMessageLink', ['root']);

export const sectionMessageCheckboxClasses = generateUtilityClasses('SectionMessageCheckbox', [
  'root',
]);

export const sectionMessageTextListClasses = generateUtilityClasses('SectionMessageTextList', [
  'root',
  'item',
]);
